import { render, staticRenderFns } from "./r-daily-bonus-config-dialog.vue?vue&type=template&id=3283ca47&scoped=true"
import script from "./r-daily-bonus-config-dialog.vue?vue&type=script&lang=js"
export * from "./r-daily-bonus-config-dialog.vue?vue&type=script&lang=js"
import style0 from "./r-daily-bonus-config-dialog.vue?vue&type=style&index=0&id=3283ca47&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3283ca47",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3283ca47')) {
      api.createRecord('3283ca47', component.options)
    } else {
      api.reload('3283ca47', component.options)
    }
    module.hot.accept("./r-daily-bonus-config-dialog.vue?vue&type=template&id=3283ca47&scoped=true", function () {
      api.rerender('3283ca47', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/daily-bonus/r-daily-bonus-config-dialog.vue"
export default component.exports